document.addEventListener('DOMContentLoaded', function () {
  // Logout when clicking the logout button, happens client-side
  // because of html caching
  const $logout = document.querySelector('.logout-link');
  if ($logout) {
    $logout.addEventListener('click', function (e) {
      e.preventDefault();
      window.account.unsetUserData();
      window.favorite.reset();
      window.location = this.href;
    });
  }
});
